import React, { useState, useRef, useEffect } from "react";
import "./TimelineScheduler.css"; // Import your custom styles
import CustomScrollbar from "../CustomScrollbar/CustomScrollbar";

import {
  Col,
  Row,
  Modal,
  ModalBody,
  Form,
  FormGroup,
  Label,
  Input,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Button
} from "reactstrap";

import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import { Calendar } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { enGB } from "date-fns/locale";
import { FaCar } from "react-icons/fa6";
import { FaParking } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import { IoIosInformationCircleOutline } from "react-icons/io";
import ReactDOM from "react-dom";
import { format } from 'date-fns';

import apiRequest from '../../api';


// Helper function to convert time to minutes from midnight
const timeToMinutes = (time) => {
  
  const date = new Date(time);
  return date.getHours() * 60 + date.getMinutes();
};
const ParkingLotDisplay = ({ parkingLot }) => {
  const textRef = useRef(null);
  const containerRef = useRef(null);
  const [shouldRotate, setShouldRotate] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [animationDuration, setAnimationDuration] = useState(5);

  useEffect(() => {
    if (textRef.current && containerRef.current) {
      const textWidth = textRef.current.scrollWidth;
      const containerWidth = containerRef.current.clientWidth;
      setShouldRotate(textWidth > containerWidth);
      const speed = 30; // Pixels per second
      const duration = textWidth / speed;
      setAnimationDuration(duration);
    }
  }, [parkingLot]);

  return (
    <div className="parking-lot" style={{
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      position: 'relative',
      overflow: 'hidden'
    }}>
      <div style={{
        width: window.innerWidth > 768?'60%':'50%',
        flexShrink: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginLeft: '5px'
      }}>
        <img 
          src="/assets/img/parked-car 1.png" 
          style={{
            width: '80%',
            objectFit: 'contain'
          }}
          className="mx-1"
        />
      </div>
      <div 
        ref={containerRef}
        style={{
          width: window.innerWidth > 768?"40%":"50%",
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          display: "flex",
          justifyContent: "begin", // Center horizontally
          alignItems: "center", // Center vertically
          marginRight: '5px',
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div
          ref={textRef}
          style={{
            display: 'inline-block',
            animation: shouldRotate && isHovered ? `marquee ${animationDuration}s linear infinite` : 'none',
            
          }}
        >
          {parkingLot}
        </div>
      </div>

      <style>
        {`
          @keyframes marquee {
            0% {
              transform: translateX(0%);
            }
            100% {
              transform: translateX(-100%);
            }
          }
        `}
      </style>
    </div>
  );
};
const TimelineScheduler = ({ onEdit, fetchReservations, baseGroups = [], items = [] }) => {
  const selectedLanguageRef = useRef(localStorage.getItem('Language') || 'EN');
  useEffect(() => {
    // Handle changes from other tabs/windows and local changes
    const handleLanguageChange = (event) => {
      selectedLanguageRef.current = event.detail['selectedLanguage'];
    };

    window.addEventListener('languageChange', handleLanguageChange);
    return () => {
      window.removeEventListener('languageChange', handleLanguageChange);
    };
  }, []);
  
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [infoModal, setInfoModal] = useState(false)
  const { pathname } = useLocation()
  const [cursorPosition, setCursorPosition] = useState({ x: 0, y: 0 });
  const [scrollX, setScrollX] = useState(0);
  const [scrollY, setScrollY] = useState(0);

  const [formDetails, setFormDetails] = useState({
    date: new Date(),
    inTime: "",
    outTime: "",
    name: "",
    company: "",
  });
  const scrollRef = useRef(null);
  const divRef = useRef(null);

  const toggleModal = (item) => {
    onEdit(item);
  }
  const toggleDropdown = (id, event) => {
    if (dropdownOpen === id) {
      setDropdownOpen(null);
    } else {
      // Adjust the cursor position relative to the slot


      // Get the scrollable container's offset
      const container = document.querySelector(".scheduler-container");
      const containerRect = container.getBoundingClientRect();

      // setCursorPosition({
      //   x: boundingRect.left - containerRect.left + container.scrollLeft + boundingRect.width / event.clientX, // Adjust horizontally
      //   y: boundingRect.top - containerRect.top + container.scrollTop + boundingRect.height + 5, // Adjust vertically
      // });
      const isLastItem = items[items.length - 1].id === id;
      setCursorPosition({
        x: event.clientX - containerRect.left + container.scrollLeft - 150, // Adjust X relative to container
        y: isLastItem ? 'unset' : "unset" // Adjust Y relative to container
      });

      setDropdownOpen(id);
    }
  };
  const onDelete = async (item) => {
    try {
      const token = sessionStorage.getItem("jwt"); // Retrieve JWT token from localStorage
      const reservationCode = String(item.id).replace(/"/g, ''); // Remove quotes if they exist
      //console.log("reservationCode:", reservationCode);
      const response = await apiRequest(`/api/reservations/deleteReservation?reservationCode=${reservationCode}`, 'POST', null, token)

      //console.log("Delete results:", response);
      fetchReservations();
    } catch (error) {
      window.alert("Error deleting reservation:" + error.message);
    }
  };
  useEffect(() => {
    if (dropdownOpen) {

      const dropdownMenuNode = document.getElementById("custom-dropdown-menu");

      if (dropdownMenuNode) {
        const style = document.createElement("style");
        style.innerHTML = `
          #custom-dropdown-menu {
            transform: unset !important;
            position: absolute !important;
            left:${cursorPosition.x}px !important;
            top:${cursorPosition.y} !important;
            z-index: 1050 !important;
          }
        `;
        document.head.appendChild(style);
      }
    }
  }, [dropdownOpen, cursorPosition]);

  useEffect(() => {
    const handleScroll = () => {
      if (divRef.current) {
        setScrollX(divRef.current.scrollLeft);
        setScrollY(divRef.current.scrollTop);
      }
    };

    // Attach scroll event listener to the div
    const divElement = divRef.current;
    divElement.addEventListener("scroll", handleScroll);

    // Cleanup the event listener on component unmount
    return () => {
      divElement.removeEventListener("scroll", handleScroll);
    };
  }, []);
  //console.log(scrollY)
  useEffect(() => {
    const now = new Date();
    const minutesNow = now.getHours() * 60 + now.getMinutes();
    const currentTimePosition = (minutesNow - startOfDay) * minuteToPixelRatio;

    if (divRef.current) {
      divRef.current.scrollLeft = currentTimePosition - divRef.current.clientWidth / 2; // Center the current time
    }
  }, []);


  const [selectedItem, setSelectedItem] = useState(null);
  const toggleInfoModal = (item) => {
    setInfoModal(!infoModal)
    if (!infoModal) {
      setSelectedItem(item);
    } else {
      setSelectedItem(null);
    }
  }
  const formatTime = (date) => {
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  };

  const startOfDay = 0; // 00:00 in minutes from midnight
  const endOfDay = 24 * 60; // 24 hours in minutes
  const schedulerWidth = 6000; // Set the total width of the scheduler
  const parkingLotWidth = window.innerWidth <= 768 ? 80 : 110; // Width of the parking lot labels
  const contentWidth = schedulerWidth - parkingLotWidth; // Width for the timeline and slots
  const minuteToPixelRatio = contentWidth / (endOfDay - startOfDay); // Pixels per minute

  // Generate timeline marks at 15-minute intervals
  const timelineMarks = [];
  for (let minutes = startOfDay; minutes <= endOfDay; minutes += 15) {
    timelineMarks.push(minutes);
  }

  const handleMouseMove = (event) => {
    // Capture the cursor's current position

  };

  return (
    <React.Fragment>
      <div className='wrapper'>
        <div style={{ width: "100%", height: "52.8px", overflow: "hidden", backgroundColor: "rgba(244, 244, 244, 1)", borderTopLeftRadius: "15px", borderTopRightRadius: "15px" }} >
          <div style={{ display: "flex" }} >
            <div className="timeline-header-wrapper">
              <div className="parking-lots-header" style={{ width: `${parkingLotWidth}px`, backgroundColor: "rgba(244, 244, 244, 1)", overflow: "hidden", zIndex: 99 }}></div>
              <div className="timeline-header" style={{ width: `${contentWidth}px`, transform: `translateX(-${scrollX}px)` }}>
                {timelineMarks.map((minutes, index) => (
                  <div
                    key={index}
                    className={`timeline-mark ${minutes % 30 === 0 ? "main" : "sub"}`}
                    style={{ left: `${minutes * minuteToPixelRatio}px` }}
                  >
                    {minutes % 30 === 0 ? (
                      <>
                        <span className="time-label pb-2 ">
                          {`${String(Math.floor(minutes / 60)).padStart(2, "0")}:${String(
                            minutes % 60
                          ).padStart(2, "0")}`}
                        </span>
                        <span className="small-line" />
                      </>
                    ) : (
                      <span className="small-line" />
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div style={{ display: "flex", width: "100%", flex:1, overflow: "hidden", borderBottomLeftRadius: "15px", borderBottomRightRadius: "15px", padding:0, margin:0 }} >
          <div className="timelne-container" style={{
            width: `${parkingLotWidth}px`,
            flexShrink: 0,
            overflow: "hidden"
          }}>
            <div className="parking-lots" style={{
              transform: `translateY(-${scrollY}px)`,
              width: `${parkingLotWidth}px`
            }}>
              {baseGroups.map((group) => (
                <ParkingLotDisplay key={group.parkingLot} parkingLot={group.parkingLot} />
              ))}
            </div>
          </div>
          <div style={{ position: "relative", width: "100%"}} className="scrollbar" id="style-9" ref={divRef} >

            <div className="scheduler-container" style={{ width: schedulerWidth + 10, overflow: "hidden" }} >
              {/* Timeline Header */}



              {/* Scheduler Content */}
              <div className="scheduler-content" style={{ height: '100%' }}>
                <div>


                  <div className="slots" style={{ width: `${contentWidth}px`, marginLeft: 50 }}>
                    {/* Vertical Lines in the Timeline Body */}
                    {timelineMarks.map((minutes, index) =>
                      minutes % 30 === 0 ? (
                        <div
                          key={`line-${index}`}
                          className="vertical-line"
                          style={{ left: `${minutes * minuteToPixelRatio}px` }}
                        ></div>
                      ) : null
                    )}
                    {baseGroups.map((group) => (
                      <div key={group.parkingLot} className="slot-row" onMouseMove={handleMouseMove} >
                        {items
                          .filter((item) => item.parkingLot === group.parkingLot)
                          .map((item) => {
                            const start = timeToMinutes(item.start_time);
                            const end = timeToMinutes(item.end_time);

                            // Calculate slot position and width relative to the content width
                            const slotStart = (start - startOfDay) * minuteToPixelRatio;
                            const slotWidth = (end - start) * minuteToPixelRatio;
                            return (
                              <>
                                {(pathname.includes("security") || pathname.includes("admin")) && (
                                  <Button onClick={() => toggleInfoModal(item)} style={{ backgroundColor: "transparent", border: "none", color: "black", position: "absolute", left: (slotWidth > 25 ? (slotStart + slotWidth - 25) : (slotStart + slotWidth/2 - 6)), top: -5, bottom: 0, zIndex: 5, padding: 0, margin:0}}   >
                                    <IoIosInformationCircleOutline size={20} />
                                  </Button>
                                )}
                                <div style={{ position: "relative" }} >

                                  <Dropdown isOpen={dropdownOpen === item.id} toggle={(e) => toggleDropdown(item.id, e)} style={{ position: "relative" }}   >

                                    <DropdownToggle
                                      key={item.id}
                                      // disabled={item.username === ""}
                                      className={pathname.includes("security") || pathname.includes("admin") ? "manager-slots" : `occupied-slot`}
                                      style={{
                                        left: `${slotStart}px`,
                                        width: `${slotWidth}px`,
                                        bottom: -26,
                                        background:
                                          pathname.includes("security") || pathname.includes("admin")
                                            ? "rgb(169, 190, 209)"
                                            : "rgb(35, 70, 136)",
                                        position: "absolute",
                                      }}
                                      disabled={item.username === ""}
                                    >
                                      {(end - start > 30) &&
                                        (
                                          <div style={{ flexDirection: "column", display: "flex", lineHeight: 0.98 }}>
                                            {/* On 'security' or 'admin' pages, always show item.name and item.title */}
                                            {(pathname.includes("security") || pathname.includes("admin")) && (
                                              <>
                                                <div>{item.username}</div>
                                                <div>{item.title}</div>
                                              </>
                                            )}

                                            {!(pathname.includes("security") || pathname.includes("admin")) && (
                                              <div>
                                                {item.username !== "" ? (
                                                  <>
                                                    <div>{item.name}</div>
                                                    <div>{item.title}</div>
                                                  </>
                                                ) : (
                                                  item.title
                                                )}
                                              </div>
                                            )}
                                          </div>
                                        )}
                                    </DropdownToggle>
                                    <DropdownMenu className="dropdown-container"
                                      id="custom-dropdown-menu"

                                    >
                                      <DropdownItem className="dropdown-btn" onClick={() => toggleModal(item)} >{selectedLanguageRef.current==='EN'?"Edit":"Izmeni"}</DropdownItem>
                                      <div className="divider mx-2 " />
                                      <DropdownItem className="dropdown-btn" onClick={() => onDelete(item)}>{selectedLanguageRef.current === 'EN' ? "Delete" : "Ukloni"}</DropdownItem>

                                    </DropdownMenu>

                                  </Dropdown>
                                </div>
                              </>
                            );
                          })}
                      </div>
                    ))}
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>


        <Modal
          isOpen={infoModal}
          toggle={toggleInfoModal}
          centered
          className="custom-model"
          backdrop="static"
          keyboard={false}
        >
          <ModalBody className="p-3">
            {selectedItem ? (
              <>
                <div className="row justify-content-center ">
                  <div className="col-md-8">
                    <FormGroup>
                      <Label className=" label fw-bold">{selectedLanguageRef.current === 'EN' ? "User:":"Korisnik:"}</Label>
                      <Label className=" label ms-2 ">{selectedItem.username}</Label>
                    </FormGroup>
                  </div>
                </div>

                <div className="row justify-content-center mt-2">
                  <div className="col-md-8">
                    <FormGroup>
                      <Label className="fw-bold label ">{selectedLanguageRef.current === 'EN' ?"Date:":"Datum:"}</Label>
                      <span className="ms-2 label">{format(selectedItem.start_time, "dd.MM.yyyy")}</span>
                    </FormGroup>
                  </div>
                </div>

                <div className="row justify-content-center mt-2">
                  <div className="col-md-8">
                    <FormGroup>
                      <Label className="fw-bold label">{selectedLanguageRef.current === 'EN' ? "Time:":"Vreme:"}</Label>
                      <span className="ms-2 label">
                        {selectedItem.start_time && selectedItem.end_time
                          ? `${formatTime(new Date(selectedItem.start_time))} - ${formatTime(new Date(selectedItem.end_time))}`
                          : "N/A"}
                      </span>
                    </FormGroup>
                  </div>
                </div>

                <div className="row justify-content-center mt-2">
                  <div className="col-md-8">
                    <FormGroup>
                      <Label className="fw-bold label ">{selectedLanguageRef.current === 'EN' ? "Name:":"Ime:"}</Label>
                      <span className="ms-2 label">{selectedItem.name}</span>
                    </FormGroup>
                  </div>
                </div>
                {selectedItem.company != "" && (
                <div className="row justify-content-center mt-2">
                  <div className="col-md-8">
                    <FormGroup>
                        <Label className="fw-bold label ">{selectedLanguageRef.current === 'EN' ? "Guest's Company" : "Kompanija Gosta"}</Label>
                        <span className="ms-2 label">{selectedItem.company}</span>
                    </FormGroup>
                  </div>
                </div>
                )}
                {selectedItem.notes!="" && (
                <div className="row justify-content-center mt-2">
                  <div className="col-md-8">
                    <FormGroup>
                      <Label className="fw-bold label ">{selectedLanguageRef.current === 'EN' ? "Note:" : "Napomena:"}</Label>
                      <span className="ms-2 label">{selectedItem.notes}</span>
                    </FormGroup>
                  </div>
                </div>
                )}
                <div className="row justify-content-center mt-4">
                  <div className="col-md-6 text-center">
                    <button
                      className=" model-btn-cancel btn btn-secondary rounded-2 py-1 px-5"
                      onClick={() => setInfoModal(false)}
                    >
                      {selectedLanguageRef.current === 'EN' ? "Close":"Zatvori"}
                    </button>
                  </div>
                </div>
              </>) : (

              <div></div>
            )
            }
          </ModalBody>
        </Modal>
      </div>
    </React.Fragment>

  );
};

export default TimelineScheduler;